import classNames from "classnames";
import styles from "./message.module.scss";

import { MarkdownComponent } from "../markdown";

import { IMessage, IShareChatMessage } from "redux/actions";
import { useSelector } from "redux/hooks";
import { useMemo } from "react";

interface IProps {
  message?: IMessage;
  shareMessage?: IShareChatMessage;
  searchQuery?: string;
  isHighlighted?: boolean;
  highlighted?: boolean;
  threads?: boolean;
  isStreaming?: boolean;
}

// Function to process message content and replace citation markers
const processCitationMarkers = (content: string, citations: string[] | undefined): string => {

  if (!citations || citations.length === 0) return content;
  let processedContent = content;
  
  // Look for citation markers in the format [n] where n is a number
  const citationRegex = /\[(\d+)\]/g;
  
 // The link will display exactly as [n] but will be clickable
 processedContent = processedContent.replace(citationRegex, (match, citationNumber) => {
  const index = parseInt(citationNumber, 10) - 1;
  if (index >= 0 && index < citations.length) {
    // Create a Markdown link that displays the original [n] but links to the citation
    return `[${match}](${citations[index]})`;
  }
  return match; // If no matching citation, keep the original text
});
  
  return processedContent;
};

export const Message = ({
  message,
  shareMessage,
  searchQuery,
  isHighlighted,
  highlighted,
  threads,
  isStreaming,
}: IProps) => {
  const { theme } = useSelector((state) => state.authReducer);

   // Process content with citation markers
   const processedContent = useMemo(() => {
    const content = message 
      ? (message?.content as string)
      : (shareMessage?.content as string);
      
    return processCitationMarkers(content, message?.citations);
  }, [message, shareMessage]);

  return (
    <div
      className={classNames(styles.message, {
        [styles.light]: theme === "light",
        [styles.dark]: theme === "dark",
        [styles.threadsLight]: theme === "light",
      })}
    >
      <MarkdownComponent
        message={processedContent}
        searchQuery={searchQuery}
        isHighlighted={isHighlighted}
        highlighted={highlighted}
        threads={threads}
        isStreaming={isStreaming}
      />
    </div>
  );
};
